import React from 'react';
import { Container } from './ui/Container';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Mark',
  details: '52, Texas',
  quote: "My wife moved to the couch because of my snoring. After 3 nights with SnoreStop™, we're back in the same bed again.",
  image: 'https://i.pravatar.cc/150?img=12'
}, {
  name: 'David',
  details: '39, Florida',
  quote: "I was embarrassed to travel with friends because I snore so loud. First night using SnoreStop™, they told me they didn't hear a thing.",
  image: 'https://i.pravatar.cc/150?img=15'
}, {
  name: 'Linda',
  details: '47, California',
  quote: 'I bought this because I was ready to divorce my husband over his snoring. Two weeks later, I finally sleep through the night again.',
  image: 'https://i.pravatar.cc/150?img=47'
}, {
  name: 'James',
  details: '61, Arizona',
  quote: 'CPAP felt like torture. SnoreStop™ felt like freedom.',
  image: 'https://i.pravatar.cc/150?img=33'
}, {
  name: 'Maria',
  details: '44, New York',
  quote: 'We stopped fighting about sleep for the first time in 8 years.',
  image: 'https://i.pravatar.cc/150?img=44'
}, {
  name: 'Robert',
  details: '58, Oregon',
  quote: "My partner was exhausted every morning. Three nights with SnoreStop™ and she's finally getting rest. Our relationship feels new again.",
  image: 'https://i.pravatar.cc/150?img=13'
}];
export function TestimonialsSection() {
  return <section className="py-16 bg-white" data-id="element-402">
      <Container data-id="element-403">
        <div className="text-center mb-12" data-id="element-404">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-405">
            Real Couples, Real Results
          </h2>
          <p className="text-xl text-gray-600" data-id="element-406">
            Join 10,000+ couples who saved their sleep.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-407">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-50 rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-408">
              <div className="flex items-center space-x-1 text-orange-500 mb-4" data-id="element-409">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-410" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-411">"{t.quote}"</p>
              <div className="flex items-center mt-auto" data-id="element-412">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-white shadow-sm" data-id="element-413">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover" data-id="element-414" />
                </div>
                <div data-id="element-415">
                  <p className="font-bold text-gray-900" data-id="element-416">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-417">{t.details}</p>
                </div>
              </div>
            </div>)}
        </div>
      </Container>
    </section>;
}